<template>
<div id="regions">
    <KazakhsanMap v-on:map-clicked="onMapClick"></KazakhsanMap>
</div>
</template>

<script>
import { mapActions } from 'vuex';
import KazakhsanMap from '../components/KazakhstanMap.vue';

export default {
  created() {
    this.$say('8.ogg');
  },
  components: {
    KazakhsanMap,
  },
  props: {
    msg: String,
  },
  methods: {
    ...mapActions('calc', ['setRegion']),
    onMapClick(attr) {
      this.setRegion(attr.mapId);
      this.$say(`${attr.mapId}.ogg`);
      this.$router.push('Aquaculture');
    },
  },

};
</script>

<style scoped>

</style>
